const targets = document.querySelectorAll('.section__section-hero-large, .section__section-hero-with-cards');

targets.forEach(target => {
    // target = .section__section-hero-large
    const targetImages = target.querySelectorAll('.hero--image img');
    const pageHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    let scrollPosition = window.scrollY;

    window.addEventListener('scroll', () => {
        scrollPosition = window.scrollY

        targetImages.forEach(image => {
            const imageHeight = image.scrollHeight;
            const imagePosition = image.offsetTop;

            if (scrollPosition >= imagePosition && scrollPosition <= imagePosition + imageHeight) {
                // in view
                const scrollPercentage = ((scrollPosition - imagePosition) / imageHeight) * 55;

                image.style.transform = `translateY(${scrollPercentage}%)`;
            }
        });
    });
});